// Package Imports
import { InboxOutlined } from '@ant-design/icons';
import { Form, Upload, message as notificationMessage } from 'antd';
import { getValueFromEvent } from '@refinedev/antd';
import { useTranslate } from '@refinedev/core';
// Project Imports
import axiosInstance from 'providers/axiosInstance/axiosInstance';
import { UploadFileInputProps } from 'components/fileUpload/type';
import useLogger from 'core/utils/useLogger';
import { REACT_APP_API_URL_PROGRAM } from 'config';

const { Dragger } = Upload;

const FileUploadInput = ({
  name,
  required,
  fileUploadEndpoint,
  fileType,
  setInputSourceFileData,
  defaultFileList,
  disabled,
  selectFile,
  fileTypeSource,
  message,
  form,
  setXmlStructure,
  setHasInvalidOutputColumn,
  setHasInvalidInputColumn,
  // type,
  setDmnErrors,
  setIsDmnValid,
}: UploadFileInputProps) => {
  const t = useTranslate();
  const logger = useLogger();
  const parseDMNFile = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      const xmlString: any = reader.result;
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlString, 'text/xml');

      setXmlStructure(xmlString);
      const outputElements = xmlDoc.getElementsByTagName('output');
      const outputNamesArray = [];
      for (let i = 0; i < outputElements?.length; i += 1) {
        const value = outputElements[i].getAttribute('name');
        outputNamesArray.push(value);
      }

      if (outputNamesArray.includes(null) || outputNamesArray.includes('')) {
        logger(
          'Output values array contains null or empty string entries.',
          ''
        );
        setHasInvalidOutputColumn(true);
        return; // Exit the function without setting the values
      }
      setHasInvalidOutputColumn(false);

      const formattedOutputValues = outputNamesArray?.map((item, index) => ({
        output: item,
        value: null,
        isSelected: false,
        id: index,
      }));
      form.setFieldsValue({ rule_output_config: formattedOutputValues });
    };
    reader.readAsText(file);
  };

  return (
    <Form.Item
      name={name}
      getValueFromEvent={getValueFromEvent}
      rules={[{ required, message }]}
    >
      <Dragger
        key={JSON.stringify(defaultFileList)}
        action=""
        disabled={disabled}
        defaultFileList={defaultFileList || []}
        beforeUpload={(file) => {
          const checkDMN = file.name.toLowerCase().split('.').pop();
          const isFileType =
            fileType.includes(file.type) || fileType.toString() === checkDMN;
          if (!isFileType) {
            // Disabling this, as no promise is required
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            notificationMessage.error(
              `${file.name} is not a ${selectFile} file`
            );
            return Upload.LIST_IGNORE;
          }
          if (checkDMN === 'dmn') {
            parseDMNFile(file);
          }

          const formData = new FormData();
          formData.append('file', file);
          formData.append('file_type', fileTypeSource);
          if (selectFile !== 'dmn') {
            axiosInstance
              .post(
                `${REACT_APP_API_URL_PROGRAM}/${fileUploadEndpoint}/`,
                formData
              )
              .then((response) => {
                setInputSourceFileData(response.data);
              })
              .catch((error) => {
                logger('Error uploading file:', error);
              });
          }
          return false;
        }}
        listType="picture"
        onChange={(info) => {
          const { file } = info;
          if (file.status === 'removed') {
            setInputSourceFileData(undefined);
          } else {
            setInputSourceFileData(file);
          }
        }}
        onRemove={() => {
          setInputSourceFileData(null);
          setHasInvalidOutputColumn(false);
          setHasInvalidInputColumn(false);
          // form.setFieldsValue({
          //   upload_type: null,
          // });
          setXmlStructure('');
          setDmnErrors([]);
          setIsDmnValid(false);
        }}
        onDrop={() => {}}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          {t('pages.fileUploadTxts.draggerInfo')}
        </p>
        <p className="ant-upload-hint">
          {t('pages.fileUploadTxts.draggerMessage')}
        </p>
      </Dragger>
    </Form.Item>
  );
};

export default FileUploadInput;
